/**
 * 規約等ページ（Bubble: P06：legal）の本文。
 *
 * 本文と最終更新日は Bubble のオプションセット `os_legal`
 * （docs/bubble_20260704/_machine/option_sets.json）をそのまま移植したもの。
 * 文面を変更するときは Bubble 側の値と揃えること。
 */

export type LegalTabKey = "terms" | "privacy" | "commercial";

export type LegalTab = {
  key: LegalTabKey;
  /** タブおよび見出しの表示名 */
  label: string;
  /** 最終更新日（os_legal.modified_date） */
  updatedOn: string;
  /** 本文。Bubble と同じく改行をそのまま表示する */
  body: string;
};

export const LEGAL_TABS: readonly LegalTab[] = [
  {
    key: "terms",
    label: "利用規約",
    updatedOn: "2025年02月17日",
    body: `この利用規約（以下、「本規約」といいます）は、Syntz合同会社（以下、「当社」といいます）が提供するウェブアプリケーション「CYCLE」（以下、「本サービス」といいます）の利用条件を定めるものです。本サービスをご利用いただく前に、本規約をよくお読みいただき、同意の上ご利用ください。
第1条（適用）
1.	本規約は、ユーザーと当社との間の本サービスの利用に関する一切の関係に適用されます。
2.	当社が本サービスに関して、本規約とは別に規定する各種のご案内や規則等（以下、「個別規定」といいます）も本規約の一部を構成するものとします。
3.	本規約の内容と個別規定が異なる場合は、個別規定の内容が優先されるものとします。
第2条（利用登録）
1.	本サービスの利用を希望する者は、本規約に同意の上、当社の定める方法により利用登録を行うものとします。
2.	当社は、利用登録の申請者が以下の事由に該当すると判断した場合、利用登録を承認しないことがあります。
o	利用登録の申請に際して虚偽の事項を届け出た場合
o	本規約に違反したことがある者からの申請である場合
o	その他、当社が利用登録を適当でないと判断した場合
第3条（ユーザーIDおよびパスワードの管理）
1.	ユーザーは、自己の責任において、本サービスのユーザーIDおよびパスワードを適切に管理および保管するものとします。
2.	ユーザーは、いかなる場合にも、ユーザーIDおよびパスワードを第三者に譲渡または貸与し、または第三者と共有することはできません。
3.	ユーザーIDおよびパスワードの管理不十分、使用上の過誤、第三者の使用による損害の責任はユーザーが負うものとし、当社は一切の責任を負いません。
第4条（禁止事項）
ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。
1.	法令または公序良俗に違反する行為
2.	犯罪行為に関連する行為
3.	当社、本サービスの他のユーザー、または第三者の知的財産権、プライバシー、名誉、その他の権利または利益を侵害する行為
4.	本サービスを利用して得られた情報を、当社の許可なく外部へ公開または漏洩する行為
5.	本サービスの運営を妨害する行為
6.	不正アクセスを試みる行為
7.	他のユーザーに関する個人情報等を収集または蓄積する行為
8.	反社会的勢力に利益を供与する行為
9.	その他、当社が不適切と判断する行為
第5条（本サービスの提供の停止等）
1.	当社は、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく、本サービスの全部または一部の提供を停止または中断することができます。
o	本サービスにかかるコンピュータシステムの保守点検または更新を行う場合
o	地震、落雷、火災、停電、天災地変などの不可抗力により、本サービスの提供が困難となった場合
o	コンピュータまたは通信回線等が事故により停止した場合
o	その他、当社が本サービスの提供が困難と判断した場合
2.	当社は、本サービスの提供の停止または中断により、ユーザーまたは第三者が被ったいかなる不利益または損害についても、一切の責任を負いません。
第6条（利用制限および登録抹消）
1.	当社は、ユーザーが以下のいずれかに該当する場合には、事前の通知なく、本サービスの全部または一部の利用を制限し、またはユーザーとしての登録を抹消することができます。
o	本規約のいずれかの条項に違反した場合
o	登録事項に虚偽の事実があることが判明した場合
o	料金等の支払債務の不履行があった場合
o	その他、当社が本サービスの利用を適当でないと判断した場合
2.	当社は、本条に基づき当社が行った行為によりユーザーに生じた損害について、一切の責任を負いません。
第7条（知的財産権）
1.	本サービスに関する知的財産権は、全て当社または正当な権利を有する第三者に帰属しています。
2.	ユーザーは、当社の事前の承諾なく、いかなる方法においても本サービスに含まれる情報を利用（複製、転載、改変、二次利用等を含む）することはできません。
3.	当社は、ユーザーが本サービスに投稿またはアップロードした文章、画像、動画その他のデータについて、本サービスの円滑な提供、システムの構築、改良、メンテナンス等に必要な範囲で、変更、削除、複製、転載、公開等の利用を行うことができるものとします。
第8条（個人情報の取扱い）
1.	当社は、本サービスの利用により取得する個人情報を、当社が別途定める「プライバシーポリシー」に従い適切に取り扱います。
2.	ユーザーは、本サービスを利用するにあたり、当社がプライバシーポリシーに従って個人情報を利用すること、および本サービスの承継に伴って個人情報が第三者へ提供される可能性があることに同意するものとします。
3.	当社は、個人情報以外にも、サービスの利用状況、アップロードしたデータ、利用日時、利用環境、IPアドレス、Cookie情報、位置情報、端末の個体識別情報等の履歴情報および特性情報を収集することがあります。
第9条（免責事項）
1.	当社は、合理的な注意を払ったうえで本サービスを提供していますが、本サービスに事実上または法律上の瑕疵（安全性、正確性、完全性、有効性、特定の目的への適合性、セキュリティ等を含む）がないことを保証するものではありません。
2.	当社は、本サービスの利用によりユーザーに生じたあらゆる損害（間接損害、特別損害、結果的損害、逸失利益を含む）について、一切の責任を負いません。ただし、本規約が消費者契約法に定める消費者契約となる場合、この免責規定は適用されません。
3.	前項ただし書に定める場合であっても、当社は、当社の過失（重過失を除く）による債務不履行または不法行為によりユーザーに生じた損害のうち、特別な事情から生じた損害について、一切の責任を負いません。
4.	当社は、本サービスに関して、ユーザー間またはユーザーと第三者との間に生じた取引、連絡、紛争等について、一切責任を負いません。
第10条（サービス内容の変更等）
1.	当社は、常に本サービスの変更および改善を行うことがあり、ユーザーに通知することなく、本サービスの内容や利用条件を変更または本サービスの提供を中止することがあります。
2.	当社は、前項に基づき当社が行った措置によりユーザーに生じた損害について、一切の責任を負いません。
第11条（利用規約の変更）
1.	当社は、必要と判断した場合には、ユーザーに通知することなく、いつでも本規約を変更することができます。
2.	変更後の本規約は、本サービス上に掲載された時点から効力を生じるものとし、ユーザーは変更後の規約に同意したものとみなされます。
第12条（準拠法および管轄裁判所）
1.	本規約の解釈にあたっては、日本法を準拠法とします。
2.	本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を第一審の専属的合意管轄裁判所とします。
第13条（協議解決）
本規約に定めのない事項や疑義が生じた場合には、当社とユーザーは誠意をもって協議し、解決するものとします。`,
  },
  {
    key: "privacy",
    label: "プライバシーポリシー",
    updatedOn: "2025年02月17日",
    body: `Syntz合同会社（以下、「当社」といいます）は、当社が提供するサービスCYCLE（以下、「本サービス」といいます）におけるユーザーの個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下、「本ポリシー」といいます）を定めます。
第1条（総則）
1. 当社は、個人情報の重要性を認識し、その適正な取扱いと保護に努めます。
2. 本ポリシーは、当社が本サービスにおいて収集・利用する個人情報の取扱いに関する基本的な方針を定めるものです。
第2条（関係法令・ガイドライン等の遵守）
当社は、個人情報の取扱いに関して、「個人情報の保護に関する法律」（以下、「個人情報保護法」といいます）その他の関連法令およびガイドラインを遵守します。
第3条（個人情報の定義）
本ポリシーにおいて「個人情報」とは、個人情報保護法第2条第1項に定める「個人情報」を指し、生存する個人に関する情報であり、氏名、生年月日、住所、電話番号、メールアドレス、その他の記述、音声、映像、個人識別符号等により特定の個人を識別できるものをいいます。
第4条（個人情報の収集方法）
当社は、以下の方法で個人情報を収集します。
1. ユーザー自身による提供：ユーザーが本サービスの利用登録やお問い合わせ等を行う際に、氏名、メールアドレス、電話番号等の情報を直接ご提供いただきます。
2. 自動的な収集：クッキー（Cookie）やウェブビーコン等の技術を用いて、アクセスログ、端末情報、位置情報等を自動的に収集します。
第5条（個人情報の利用目的）
当社は、収集した個人情報を以下の目的で利用します。
1. 本サービスの提供および運営のため
2. ユーザーからのお問い合わせやご相談に対応するため
3. 本サービスの改善や新サービスの開発のための分析
4. メンテナンス、重要なお知らせ等の連絡のため
5. キャンペーン、アンケート、広告等の情報提供のため（ユーザーの同意がある場合）
6. 利用規約等に違反する行為への対応および防止のため
7. 法令や行政機関からの要請に基づく対応のため
8. その他、上記利用目的に付随する目的のため
第6条（個人情報の第三者提供）
1. 当社は、次の場合を除き、ユーザーの個人情報を第三者に提供しません。
  1. ユーザーの同意がある場合
  2. 法令に基づく場合
  3. 人の生命、身体または財産の保護のために必要がある場合
  4. 公衆衛生の向上や児童の健全な育成の推進のために特に必要がある場合
  5. 国の機関や地方公共団体等が法令の定める事務を遂行するために協力する必要がある場合
2. 前項にかかわらず、以下の場合は第三者提供に該当しません。
  1. 当社が利用目的の達成に必要な範囲で個人情報の取扱いを委託する場合
  2. 合併、会社分割、事業譲渡等により個人情報が提供される場合
  3. 個人情報を特定の者との間で共同利用する場合で、共同利用される個人情報の項目、共同利用者の範囲、利用目的、管理責任者を事前に通知または公表している場合
第7条（個人情報の安全管理）
1. 当社は、個人情報の漏洩、滅失、毀損を防止するために、適切な安全管理措置を講じます。
2. 従業員および委託先に対し、個人情報の適正な取扱いに関する教育・指導を行い、適切な監督を行います。
第8条（個人情報の開示・訂正・利用停止等）
1. ユーザーは、当社が保有する自身の個人情報の開示、訂正、追加、削除、利用停止、消去、第三者提供の停止（以下、「開示等」といいます）を求めることができます。
2. 開示等の請求があった場合、当社は本人確認を行い、合理的な範囲で速やかに対応します。ただし、法令に基づき開示等を行わない場合があります。
3. 開示等の請求方法および手数料については、以下の「お問い合わせ窓口」までご連絡ください。
第9条（クッキー等の利用について）
1. 当社は、ユーザーの利便性向上やサービス改善のため、クッキーや類似の技術を使用します。
2. ユーザーは、ブラウザ設定によりクッキーの受け取りを拒否することができますが、その場合、本サービスの一部機能が利用できない場合があります。
第10条（アクセス解析ツールの利用）
当社は、本サービスの利用状況を把握するために、Google Analytics等のアクセス解析ツールを利用します。これらのツールは、クッキーを通じてトラフィックデータを収集しますが、個人を特定する情報は含まれておりません。詳細については、各ツールのプライバシーポリシーをご確認ください。
第11条（個人情報の国外への移転）
当社は、個人情報を国外にある第三者に提供する場合、個人情報保護法その他の関連法令を遵守し、適切な保護措置を講じます。
第12条（未成年者の個人情報）
1. 未成年者が本サービスを利用する場合、必ず法定代理人の同意を得てください。
2. 当社は、13歳未満の児童から意図的に個人情報を収集しません。もし13歳未満の児童から個人情報を取得したことが判明した場合、速やかに削除します。
第13条（プライバシーポリシーの改定）
1. 当社は、必要に応じて本ポリシーを改定することがあります。
2. 改定後のプライバシーポリシーは、本サービス上に掲載した時点で効力を生じます。
第14条（お問い合わせ窓口）
本ポリシーに関するお問い合わせ、個人情報の取扱いに関するご質問や苦情、開示等の請求は、以下の窓口までご連絡ください。
Syntz合同会社
住所： 〒150-0044
東京都渋谷区円山町5番5号 Navi渋谷Ⅴ3階
Eメールアドレス： support@syntz-cycle.com
受付時間： 平日9:00～18:00（土日祝日、年末年始を除く）`,
  },
  {
    key: "commercial",
    label: "特定商法に基づく表記",
    updatedOn: "2026年09月27日",
    body: `- 販売業者：Syntz合同会社
- 代表責任者：大平 亮
- 所在地：〒150-0044　東京都渋谷区円山町5番5号 Navi渋谷Ⅴ3階
- お問い合わせ先：
  - 電話番号：サービスの特性上、お電話でのお問い合わせは受け付けておりません。お問い合わせはメールにてお願いいたします。
  - メールアドレス：support@syntz-cycle.com
- 販売価格：決済にかかわる手数料として、お支払いプランの金額（1口あたり）の8％（13,000円以上は5％。1円未満は四捨五入）を、お支払いプランの金額に上乗せして頂戴いたします。
- 商品代金以外の必要料金：なし
- 代金の支払い時期と方法：
  - 支払い方法：クレジットカード、銀行振込
  - 支払い時期：決済時に、お支払いプランの金額とあわせてお支払いいただきます。
- サービスの提供時期：決済完了後、即時にサービスをご利用いただけます。
- キャンセルについて：サービスの性質上、決済完了後のキャンセルや返金はお受けできません。
- 返品・交換について：商品やサービスの特性上、返品・交換はお受けしておりません。
- 動作環境：インターネットに接続できる環境と、最新のウェブブラウザが必要です。
- 不良品の取り扱い：サービスの不具合がございましたら、上記お問い合わせ先までご連絡ください。速やかに対応いたします。
- 資格・免許等：特になし`,
  },
];

/** クエリ `tab` を LegalTabKey に解決する。未指定・不正値は利用規約 */
export const resolveLegalTabKey = (raw: string | null): LegalTabKey => {
  const found = LEGAL_TABS.find((t) => t.key === raw);
  return found ? found.key : "terms";
};
